import { Box } from '@mantine/core';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import FeedTypeAllowlistPanel from '../../components/FeedBandit/FeedTypeAllowlistPanel';
import KnowledgeBaseTab from '../../components/KnowledgeBase/KnowledgeBaseTab';
import SuperAdminAiModels from '../../components/SuperAdmin/SuperAdminAiModels';
import superAdminAccents from '../../components/SuperAdmin/superAdminAccents.module.css';
import SuperAdminBotClassification from '../../components/SuperAdmin/SuperAdminBotClassification';
import SuperAdminBotIpRanges from '../../components/SuperAdmin/SuperAdminBotIpRanges';
import SuperAdminChatBotSettings from '../../components/SuperAdmin/SuperAdminChatBotSettings';
import SuperAdminEmailTestSend from '../../components/SuperAdmin/SuperAdminEmailTestSend';
import SuperAdminInvoices from '../../components/SuperAdmin/SuperAdminInvoices';
import SuperAdminNavbar from '../../components/SuperAdmin/SuperAdminNavbar';
import SuperAdminOperationalEmailEvents from '../../components/SuperAdmin/SuperAdminOperationalEmailEvents';
import SuperAdminOperationalEmails from '../../components/SuperAdmin/SuperAdminOperationalEmails';
import SuperAdminPartners from '../../components/SuperAdmin/SuperAdminPartners';
import SuperAdminSidebar from '../../components/SuperAdmin/SuperAdminSidebar';

const DEFAULT_SECTION = 'invoices';

const SuperAdminPage = () => {
  const { section: requestedSection } = useParams();
  const navigate = useNavigate();

  // Keyed by the sidebar's item ids. Every section stays mounted and the
  // inactive ones are hidden, which is what the Tabs.Panel strip this replaced
  // did (see `keepMountedMode` in src/theme.jsx): a section keeps its
  // in-progress form state and refetches nothing when it is switched away from.
  const sections = {
    invoices: <SuperAdminInvoices />,
    partners: <SuperAdminPartners />,
    operationalEmails: <SuperAdminOperationalEmails />,
    operationalEmailEvents: <SuperAdminOperationalEmailEvents />,
    chatBotSettings: <SuperAdminChatBotSettings />,
    knowledgeBase: <KnowledgeBaseTab corpus="system" isSuperAdmin />,
    aiModels: <SuperAdminAiModels />,
    emailTestSend: <SuperAdminEmailTestSend />,
    feedBandit: <FeedTypeAllowlistPanel />,
    botIpRanges: <SuperAdminBotIpRanges />,
    botClassification: <SuperAdminBotClassification />,
  };

  const section = sections[requestedSection] ? requestedSection : DEFAULT_SECTION;

  // Canonicalise the address bar, so that /superAdmin and an unknown section both settle on a
  // URL that round-trips. Replace rather than push: landing on a bare /superAdmin should not
  // leave a history entry that Back would bounce off.
  useEffect(() => {
    if (requestedSection !== section) {
      navigate(`/superAdmin/${section}`, { replace: true });
    }
  }, [requestedSection, section, navigate]);

  return (
    <div className="domain-page-layout">
      <SuperAdminNavbar />
      <div className="domain-page-body">
        <SuperAdminSidebar value={section} onChange={(id) => navigate(`/superAdmin/${id}`)} />
        <Box className="App">
          <Box className={superAdminAccents.page}>
            {Object.entries(sections).map(([id, element]) => (
              <Box key={id} display={id === section ? undefined : 'none'}>
                {element}
              </Box>
            ))}
          </Box>
        </Box>
      </div>
    </div>
  );
};
export default SuperAdminPage;
